import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { MatDialog } from '@angular/material/dialog'
import { RouterModule } from '@angular/router'
import { reloginIfRequired$ } from '@saniup-webapps/shared'
import { ShortcutService } from './services/shortcut.service'

@Component({
  imports: [RouterModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly shortcutService = inject(ShortcutService)
  readonly dialog = inject(MatDialog)

  title = 'leistungserbringer-webapp'
  constructor() {
    reloginIfRequired$().pipe(takeUntilDestroyed()).subscribe()
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    this.shortcutService.receiveEvent(event)
  }
}
